module.exports = __webpack_public_path__ + "img/2025-08-16b_2.4c84a580.jpg";